module.exports = __webpack_public_path__ + "img/casino.b40fd50f.jpg";